import type { ActionTree } from 'vuex';

import type { RootState } from '../../store/root.types';
import { UniversalLinkService } from '../../api/unversal-link/services/universal-link.service';
import type { VerifyLinkResponse } from '../../api/unversal-link/types/verify-link-response';
import type { RedirectURLError } from '../../api/unversal-link/types/redirect-url-error';
import { getDefaultState } from './universal-link.constants';
import { UniversalLinkAction, UniversalLinkMutation } from './universal-link.types';
import type { UniversalLinkState } from './universal-link.types';

export const actions: ActionTree<UniversalLinkState, RootState> = {
  async [UniversalLinkAction.VerifyLink]({ commit, dispatch }, linkId: string) {
    commit(UniversalLinkMutation.SetLoading, true);
    commit(UniversalLinkMutation.SetLoaded, false);
    commit(UniversalLinkMutation.SetLoadingError, false);
    try {
      const response: VerifyLinkResponse = await UniversalLinkService.verify(linkId);
      dispatch(UniversalLinkAction.VerifyLinkSuccess, response);
    } catch (error) {
      dispatch(UniversalLinkAction.VerifyLinkFailed, error.toString());
    }
  },
  [UniversalLinkAction.VerifyLinkSuccess]({ commit }, response: VerifyLinkResponse) {
    commit(UniversalLinkMutation.SetVerifyLinkResponse, response);
    commit(UniversalLinkMutation.SetLoaded, true);
    commit(UniversalLinkMutation.SetLoading, false);
  },
  [UniversalLinkAction.VerifyLinkFailed]({ commit }) {
    commit(UniversalLinkMutation.SetLoadingError, true);
    commit(UniversalLinkMutation.SetLoaded, false);
    commit(UniversalLinkMutation.SetLoading, false);
  },

  async [UniversalLinkAction.LoadRedirectURL](
    { commit, dispatch },
    { gdprConsent, email, documentId }: { gdprConsent: boolean; email: string; documentId: string }
  ) {
    commit(UniversalLinkMutation.SetRedirectURLError, getDefaultState().redirectURLError);
    commit(UniversalLinkMutation.SetLoadingRedirectURL, true);
    try {
      const redirectURL: string = await UniversalLinkService.identifyRecipient(
        gdprConsent,
        documentId,
        email
      );
      dispatch(UniversalLinkAction.LoadRedirectURLSuccess, redirectURL);
    } catch (e) {
      dispatch(UniversalLinkAction.LoadRedirectURLFailed, e);
    }
  },
  [UniversalLinkAction.LoadRedirectURLSuccess]({ commit }, url: string) {
    commit(UniversalLinkMutation.SetRedirectURL, url);
  },
  [UniversalLinkAction.LoadRedirectURLFailed]({ commit }, error: RedirectURLError) {
    commit(UniversalLinkMutation.SetRedirectURLError, error);
    commit(UniversalLinkMutation.SetLoadingRedirectURL, false);
  },
};
